// extracted by mini-css-extract-plugin
module.exports = {"button":"SelectAddress_button__3wID-","coins":"SelectAddress_coins__dD_SQ"};